var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCyclist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 98,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.68 97.23c-33.098 0-28.904-43.43-1.562-50.058l7.949 26.445-6.309.785-6.422-17.516c-13.072 8.305-15.02 30.552 4.656 32.832 22.975 2.663 32.215-32.997 8.742-35.778l-2.02-7.6c.215-.004.426-.015.643-.015 33.51 0 27.049 50.905-5.677 50.905zm-3.707-78.969c-6.914 2.701-13.15-3.072-12.658-8.497l-6.002-3.553s.723-4.61.855-4.645C84.193.02 94.508-.81 97.4 5.163c2.67 5.513-.224 11.846-3.427 13.098zM44.818 51.506l-5.295 5.792c-2.143-1.733-4.994-2.945-8.629-3.366C7.257 51.193-2.97 86.802 22.206 89.72c12.947 1.5 21.52-9.165 22.348-19.262-3.207-.093-5.715-4.95-1.564-9.029 3.574-3.516 12.551-11.691 12.551-11.691l-19-14.423.73-8.368c7.728-8.289 26.84-14.201 38.876-12.956l5.77 18.647s6.95 1.023 10.994 1.562c4.2.56 3.748 6.914 3.748 6.914l-21.662.808-5.568-8.585-10.785.058s5.094 6.868 8.812 12.185c2.164 3.093.797 8.203.797 8.203L51.63 65.736C53 80.118 42.876 97.231 23.896 97.231c-35.832 0-27.96-50.905 5.678-50.905 6.608-.001 11.641 1.999 15.244 5.18zm16.18 28.181c-1.69-3.814-4.656-12.242-4.656-12.242l8.707-3.606 5.406 17.827c-2.275 1.946-7.725 1.927-9.457-1.979z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyclist);
export default __webpack_public_path__ + "static/media/cyclist.e11aa5d63d1a1c0f2febaee5377ef241.svg";
export { ForwardRef as ReactComponent };